import React from "react";
import styled from "styled-components";
import { COLORS } from "../../../COLORS";
import { useNavigate } from "react-router-dom";

const Directions = () => {
  const nav = useNavigate();
  return (
    <StyledDirections>
      <div className="card-direction" onClick={() => nav("/business")}>
        BUSINESS 🔥
      </div>
      <div className="card-direction" onClick={() => nav("/annonces")}>
        ANNONCES
      </div>
      <div className="card-direction" onClick={() => nav("/evenements")}>
        EVENEMENTS
      </div>
      <div className="card-direction orange" onClick={() => nav("/post")}>
        PUBLIER
      </div>
    </StyledDirections>
  );
};

export default Directions;
const StyledDirections = styled.section`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 20px;
  margin: 20px 0px;
  background: ${COLORS.main};
  .card-direction {
    width: 20%;
    padding: 20px 10px;
    margin: 10px;
    border: solid 2px ${COLORS.green};
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${COLORS.footer};
    color: ${COLORS.border_and_text_blue};
    font-weight: 800;
    cursor: pointer;
    transition: 0.3s;
  }
  .orange {
    background: ${COLORS.orange_new};
    color: ${COLORS.white};
    border: solid 2px ${COLORS.orange_new};
  }
  .card-direction:hover {
    transition: 0.3s;
    background: ${COLORS.main};
  }
  @media screen and (max-width: 445px) {
    .card-direction {
      width: 40%;
    }
  }
`;
